// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".typedText>.text[data-v-32755524]{border-right:.2rem solid #777;line-height:1.7}.hiddenFullText[data-v-32755524]{line-height:1.7}", ""]);
// Exports
module.exports = exports;
